<template>
  <div style="overflow-y: auto;">
    <div class="pl-1">
      <v-progress-linear
        indeterminate
        color="primary"
        class="pl-1"
        v-if="!ordersIsFetched || !statusesIsFetched"
      ></v-progress-linear>
    </div>
    <span v-if="orders.length === 0 && ordersIsFetched">
      <v-alert outlined color="primary" class="ma-1">
        {{ $t("common.no_data_available") }}
      </v-alert>
    </span>
    <v-simple-table v-else height="211">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">{{ $t("common.status") }}</th>
            <th class="text-left">#</th>
            <th class="text-left">{{ $t("common.total_sum") }}</th>
            <th class="text-left">
              {{ $t("common.customer") }}
            </th>
            <th class="text-left">{{ $t("common.car") }}</th>
            <th class="text-left">{{ $t("common.date") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orders.slice(0, limit)" :key="order.id">
            <td>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <strong v-bind="attrs" v-on="on">
                    <span
                      :style="{
                        background: order && order.status && order.status.color,
                      }"
                      class="mpa-1 d-inline-block mx-1 status-square"
                    ></span>
                  </strong>
                </template>
                {{
                  order.status.system
                    ? $t("common.orderSystemStatusNames." + order.status.name)
                    : order.status.name
                }}
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <strong v-bind="attrs" v-on="on">
                    <span
                      :style="{
                        background:
                          order && order.status && order.status_payment.color,
                      }"
                      class="pa-1 d-inline-block mx-1 status-circle"
                    ></span>
                  </strong>
                </template>
                {{
                  order.status.system
                    ? $t("common.paymentStatuses." + order.status_payment.name)
                    : order.status.name
                }}
              </v-tooltip>
            </td>
            <td>
              <span
                class="mr-3 dashed"
                @click.stop="
                  orderWindow.orderId = order.id;
                  orderWindow.isVisible = true;
                "
              >
                #{{ order.human_number }}
              </span>
            </td>
            <td>{{ formatCurrency(order.total_sum) }}</td>
            <td>
              <span v-if="order.customer">
                {{ order.customer.full_name }}
                {{
                  order.customer.is_company == 1
                    ? "[" + order.customer.legal_name + "]"
                    : ""
                }}
              </span>
              <span v-else>
                {{ $t("viewOrders.customer_is_deleted") }}
              </span>
            </td>
            <td>
              <template v-if="order.car">
                <div class="d-inline">
                  <img
                    align="center"
                    class="brandLogoMiddle mr-1"
                    v-if="!!brandURL(order.car.brand)"
                    :src="brandURL(order.car.brand)"
                    :title="order.car.brand && order.car.brand.toUpperCase()"
                  />
                  <span v-else>
                    {{ order.car && order.car.brand.toUpperCase() }}
                  </span>
                </div>

                  <span class="text-caption pr-2" v-if="order.car"
                    >{{ order.car.brand }} {{ order.car.family }}
                    {{ order.car.model }}</span
                  >
                  <beauty-car-number
                    :number="order.car.car_number ? order.car.car_number : ''"
                    class="d-inline-block small"
                  />

              </template>
            </td>
            <td>
                      <span class="text-caption"
                      >{{ order.created_at | moment("DD.MM.YYYY") }}
          {{ order.created_at | moment("HH:mm") }}</span
                      >
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <order-window
      :is-visible="orderWindow.isVisible"
      :order-id="orderWindow.orderId"
      @hide="
        orderWindow.orderId = null;
        orderWindow.isVisible = false;
      "
      @update="
        (data) => {
          order = orders.find((o) => o.id === data.id);
          order = data;
        }
      "
    />
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import OrderWindow from "@/components/order/OrderWindow.vue";
import BeautyCarNumber from "@/components/common/BeautyCarNumber.vue";

export default {
  name: "MainWidgetOrders",
  components: { BeautyCarNumber, OrderWindow },
  mixins: [CommonMixin],
  props: {
    limit: {
      type: Number,
      default: 5,
    },
  },
  data: () => ({
    orderWindow: {
      orderId: null,
      isVisible: false,
    },
  }),
  mounted() {
    this.getData();
  },
  computed: {
    ...mapFields("statuses", ["order_statuses", "order_payments_statuses"]),
    ...mapFields("orders", ["orders", "tableOptions"]),
    ...mapFields("orders", { ordersIsFetched: "fetched" }),
    ...mapFields("statuses", { statusesIsFetched: "fetched" }),
  },
  methods: {
    getData() {
      this.$store.dispatch("statuses/statusesGet").then(() => {
        this.ordersGet();
      });
    },
    ordersGet(name = null) {
      this.tableOptions = {
        page: 1,
        last_page: 1,
        itemsPerPage: this.limit,
        sortBy: ["human_number"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false,
      };
      let systemOrderStatuses = this.order_statuses.reduce((res, current) => {
        res.push(current.id);
        return res;
      }, []);
      let shopOrderStatuses = this.order_statuses.reduce((res, current) => {
        res.push(current.id);
        return res;
      }, []);
      let systemOrderPaymentStatuses = this.order_payments_statuses.reduce(
        (res, current) => {
          res.push(current.id);
          return res;
        },
        []
      );

      this.$store.dispatch("orders/ordersGet", {
        systemOrderPaymentStatuses,
        systemOrderStatuses,
        shopOrderStatuses,
      });
    },
  },
  watch: {
    limit() {
      this.ordersGet();
    },
  },
};
</script>

<style scoped>
.brandLogoMiddle {
  width: 16px;
}
</style>
